import { Link } from "react-router-dom";

const contentLinks = [
  { to: "/category/news", label: "动漫资讯" },
  { to: "/category/recommend", label: "番剧推荐" },
  { to: "/category/character", label: "角色介绍" },
  { to: "/search", label: "站内搜索" },
];

const aboutLinks = [
  { to: "/about", label: "关于我们" },
  { to: "/about", label: "联系方式" },
  { to: "/about", label: "使用说明" },
  { to: "/about", label: "版权声明" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-primary-50 mt-16">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-foreground-950 font-black text-lg font-display">
                蕉
              </span>
              <span className="font-display font-black text-lg text-primary-50">香蕉动漫</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100/90 max-w-md">
              香蕉动漫致力于为动漫爱好者提供丰富的动画资讯、角色介绍及动漫推荐，
              涵盖热门番剧和经典动画，帮助每一位观众发现属于自己的精彩世界。
            </p>
            <p className="mt-3 text-xs text-primary-200/80">
              本站内容均为演示数据，正式上线前需接入真实内容接口。
            </p>
          </div>

          <div>
            <h4 className="font-display font-bold text-sm mb-4 text-primary-50">内容导航</h4>
            <ul className="space-y-2.5">
              {contentLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-primary-100/85 hover:text-primary-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-sm mb-4 text-primary-50">关于本站</h4>
            <ul className="space-y-2.5">
              {aboutLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-primary-100/85 hover:text-primary-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-100/80">
            © 2026 香蕉动漫 Banana Anime. 保留所有权利。
          </p>
          <p className="text-xs text-primary-100/80">
            本站为动漫内容演示站点 · 不提供真实播放与下载
          </p>
        </div>
      </div>
    </footer>
  );
}